import { render, staticRenderFns } from "./Outbrain.vue?vue&type=template&id=d2ddc4ae"
import script from "./Outbrain.vue?vue&type=script&lang=js"
export * from "./Outbrain.vue?vue&type=script&lang=js"
import style0 from "./Outbrain.vue?vue&type=style&index=0&id=d2ddc4ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports